import styled from 'styled-components';

export const StyledDropZone = styled.span`
  outline: none;
`;
